import { AxiosResponse } from 'axios-cad-nx';
import {
    ApiResultReleaseUnitsResponse,
    ReleaseUnitsResource,
    UnitStateTransitionPermissionEnum,
} from '@mark43/cad-api';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '~/api-client';

export function useReleaseUnitsMutation(): UseMutationResult<
    AxiosResponse<ApiResultReleaseUnitsResponse, any>,
    unknown,
    number[],
    unknown
> {
    const apiClient = useApiClient();
    const mutation = useMutation((unitIds: number[]) => {
        return apiClient.request<ReleaseUnitsResource.ReleaseUnits>({
            method: 'POST',
            url: `release_units/`,
            data: {
                unitIds,
                actingTransitioner: UnitStateTransitionPermissionEnum.DISPATCHER.name,
            },
        });
    });
    return mutation;
}
